module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content Bank Soal Gratis")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Content Soal Gratis")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    staticStyle: {
      "max-width": "200px",
      "margin-right": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Import Soal\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/content/itembank-form',
          query: {
            mapel: _vm.$route.query.mapel
          }
        })
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Soal Baru\n            ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.items,
      "headers": _vm.headers,
      "hasEdit": true,
      "currentPageProp": this.params.page,
      "hasAction": true
    },
    on: {
      "selected": function($event) {
        _vm.selectedItem = $event
      },
      "editNewTab": function($event) {
        return _vm.editSoalNewTab($event)
      },
      "dblClicked": function($event) {
        return _vm.editSoal()
      },
      "deleted": function($event) {
        return _vm.deleteSoal($event)
      }
    }
  }), _vm._v(" "), (_vm.$route.name === 'FreeItemBank') ? _c('div', [_c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                " + _vm._s(this.maxPage) + "\n              ")])]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.params.page - 1)
      }
    }
  }, [_vm._v("\n                Previous\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.page),
      expression: "params.page"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxPage
    },
    domProps: {
      "value": (_vm.params.page)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.goToPage(_vm.params.page)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "page", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.params.page + 1)
      }
    }
  }, [_vm._v("\n                Next\n              ")])]) : _vm._e()]) : _vm._e()], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58b6f300","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/free_itembank/FreeItemBank.vue
// module id = 1348
// module chunks = 0